import { render } from "./AppointmentWizard.vue?vue&type=template&id=1de7c434"
import script from "./AppointmentWizard.vue?vue&type=script&lang=ts"
export * from "./AppointmentWizard.vue?vue&type=script&lang=ts"

import "./AppointmentWizard.vue?vue&type=style&index=0&id=1de7c434&lang=css"
script.render = render

export default script